<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "@/components/widgets/preloader";
    import { mapState,mapGetters,mapActions } from "vuex"
    import Swal from "sweetalert2";    
    import { ModelListSelect } from "vue-search-select";
    import moment from "moment";
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Pending Agent Damages/Exchanges",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        Loader,
        ModelListSelect
      },
      data() {
        return {
          title: "Pending Agent Damages ",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "Pending Agent Damages",
              active: true,
            },
          ],
          totalRows: 1,
    
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          modal_id: "",
          fields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "date",
              sortable: true,
              label: "Date",
            },
            {
              key: "agent.name",
              sortable: true,
              label: "AGENT",
            },
    
            {
              key: "product.product_name",
              sortable: true,
              label: "PRODUCT",
            },
    
            {
              key: "qty",
              sortable: true,
              label: "QTY",
            },
    
            {
              key: "type",
              sortable: true,
              label: "TYPE",
            },
            
            {
              key: "description",
              sortable: true,
              label: "REASON",
            },
            {
              key: "user.name",
              sortable: true,
              label: "ADDED By",
            },
            {
              key: "dateAdded",
              sortable: true,
              label: "DATE ADDED",
            },
            {
              sortable: false,
              key: "actions",
              label: "ACTIONS",
            },
          ],
        //   agent only
            data: {
            product_id: "",
            category: 0,
            quantity: "",
            customer_id: "",
            date: moment(new Date()).format("YYYY-MM-DD"),
            description: "",
        },
        // edit unit
        editdata: {
            name: "",
            category: "",
            id: "",
        },
       
          // delete data
          deletedata: {
              name: "",
              id: "",
          },
          // Confirm spoilt product data
          confirmdata: {
            name: "",
            id: "",
          },
          //Reject Spoilt record
          rejectdata: {
              name: "",
              id: "",
          },
          dateError:'',
          quantityError:'',
          productError:'',

          //== close modal
          closeModal(modalId) {
            this.$nextTick(() => {
                this.$bvModal.hide(modalId);
            });
          },
        };
      },
      computed: {
        // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
        ]),
        ...mapGetters("agentstock", ["SaveStatus", "PendingSpoilt"]),
        ...mapGetters("agentstock", ["AgentStock"]),
        ...mapGetters("customers", ["Customers"]),


        ...mapGetters('auth',["User"]),
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.PendingSpoilt ? this.PendingSpoilt.length : 1;
        },
    
        /**
         * Todo list of records
         */
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.PendingSpoilt ? this.PendingSpoilt.length : 1;
      },
      watch: {
        show(newValue) {
          // Do whatever makes sense now
          if (newValue == true) {
            this.closeModal(this.modal_id);
            if (this.type == "success") {
              Swal.fire("Success!", this.message.msg, "success");
              // this.$toast.success(this.message.msg);
            } else {
              // this.$toast.error(this.message.msg);
              Swal.fire("Error!", this.message.msg, "error");
            }
          }
        },
      },
      methods: {
        ...mapActions({
          FetchPendingSpoilt: "agentstock/fetchPendingSpoilt",
          DeleteSpoilt: "agentstock/deleteSpoilt",
          ConfirmSpoiltStock: "agentstock/ConfirmSpoilt",
          RejectSpoiltStock: "agentstock/RejectSpoilt",
          FetchAgentStock: "agentstock/fetchAgentstock",
          FetchCustomers: "customers/fetchCustomers",
          AddSpoilt: "agentstock/addSpoilt",



        }),
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },

        resetDelete() {
          this.deletedata.name = "";
          this.deletedata.id = "";
          this.modal_id = "";
        },
        resetConfirm() {
          this.confirmdata.name = "";
          this.confirmdata.id = "";
          this.modal_id = "";
        },
        resetReject() {
          this.rejectdata.name = "";
          this.rejectdata.id = "";
          this.modal_id = "";
        },
        resetAdd() {
          this.data.product_id = "";
          this.data.category = 0;
          this.data.date = "";
          this.data.quantity = "";
          this.data.description = "";
          this.modal_id = "";
        },
        resetError() {
          this.productError = "";
          this.dateError = "";
          this.quantityError = "";
        },

        // Confirm Spoilt stock
        confirmSpoilt(modalId) {
            this.modal_id = modalId;
            this.ConfirmSpoiltStock(this.confirmdata);
        },

        showConfirmModal(data) {
        this.confirmdata.name = data.item.product.product_name;
        this.confirmdata.id = data.item.id;
        },
        showDeleteModal(data) {
        this.deletedata.name = data.item.product.product_name;
        this.deletedata.id = data.item.id;
        },
        deleteSpoilt(modalId) {
        this.modal_id = modalId;
        this.DeleteSpoilt(this.deletedata);
        },


        // Reject Spoilt stock
        rejectSpoilt(modalId) {
            this.modal_id = modalId;
            this.RejectSpoiltStock(this.rejectdata);
        },

        showRejectModal(data) {
        this.rejectdata.name = data.item.product.product_name;
        this.rejectdata.id = data.item.id;
        },

        // creating
        addSpoilt(modalId) {
      this.modal_id = modalId;

      if (this.data.product_id === "") {
        this.productError = "Product  field is required";
        return;
      } else {
        this.productError = "";
      }

      if (this.data.date === "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }

      if (this.data.quantity === "") {
        this.quantityError = "Quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }
      
      this.AddSpoilt(this.data);
    },

      },
      created() {
        this.FetchPendingSpoilt();
        this.FetchAgentStock();
        this.FetchCustomers();

      },
    };
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-9">
                    <h4 class="card-title">Pending Agent Damages</h4>
                  </div>
                  <!-- <div class="col-md-3" align="right">
                    <router-link :to="'/stock/spoilt'">
                    <b-button variant="primary">Confirmed Damages</b-button>
                    </router-link>
                  </div> -->
                  <div class="col-md-3" align="right">
                    <b-button v-b-modal.add-product-modal variant="primary"><i class="fa fa-plus"></i> Add New</b-button>
                </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                      class="datatables"
                      :items="PendingSpoilt?PendingSpoilt:[]"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
    
                    <template #cell(actions)="data">
                      <b-button-group>
                      <b-button v-if="User.role.delete_spoilt_stock == 1 && User.is_agent == 'No' && data.item.status == 0"
                          size="sm"
                          variant="danger"
                          v-b-modal.spoilt-delete-modal
                          @click="showDeleteModal(data)"
                      ><i class="fa fa-trash"></i>
                      </b-button>
                      <b-button v-if="User.role.confirm_spoilt_stock == 1 && User.is_agent == 'No' && data.item.status == 0"
                          size="sm"
                          variant="success"
                          v-b-modal.spoilt-product-modal
                          @click="showConfirmModal(data)"
                      ><i class="fa fa-check"></i>Confirm</b-button>
                      <b-button v-if="User.role.confirm_spoilt_stock == 1 && User.is_agent == 'No' && data.item.status == 0"
                          size="sm"
                          variant="warning"

                          v-b-modal.rejectspoilt-product-modal
                          @click="showRejectModal(data)"
                      ><i class="fa fa-cross"></i>Reject
                      </b-button>
                      <span class="text-info" v-if="User.is_agent == 'Yes' && data.item.status == 0">Pending</span>
                      <span class="text-success" v-if="data.item.status == 1">Confirmed</span>
                      <span class="text-warning" v-if="data.item.status == 3">Rejected</span>
                    </b-button-group>
                    
                    
                    </template>
                  </b-table>
                </div>
                <Loader  v-if="!PendingSpoilt"/>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <!-- modal confirm spoilt starts -->
        <b-modal
            header-bg-variant="danger"
            header-text-variant="light"
            body-text-variant="danger"
            footer-bg-variant="danger"
            footer-text-variant="danger"
            id="rejectspoilt-product-modal"
            hide-footer
            @hidden="resetConfirm"
        >
          <template #modal-title> Reject Spoilt Product {{ rejectdata.name }}</template>
          <div class="form-group mb-3">
            <div class="input-group">
              <h5>
                Do you want to reject this spoilt stock record? Click Proceed Button to confirm.
              </h5>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-warning"
                data-dismiss="modal"
                @click="closeModal('rejectspoilt-product-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
                type="button"
                class="btn btn-danger"
                @click="rejectSpoilt('rejectspoilt-product-modal')"
            >
              <i class="fa fa-trash"></i> Proceed
              <b-spinner
                  v-if="SaveStatus"
                  variant="light"
                  small
                  label="Rejecting"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
        <!-- modal ends -->
    
        <!-- modal confirm spoilt starts -->
        <b-modal
            header-bg-variant="warning"
            header-text-variant="light"
            body-text-variant="warning"
            footer-bg-variant="warning"
            footer-text-variant="warning"
            id="spoilt-product-modal"
            hide-footer
            @hidden="resetConfirm"
        >
          <template #modal-title> Confirm Spoilt Product {{ confirmdata.name }}</template>
          <div class="form-group mb-3">
            <div class="input-group">
              <h5>
                Do you want to confirm this spoilt stock record? Click Proceed Button to confirm.
              </h5>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="closeModal('spoilt-product-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
                type="button"
                class="btn btn-warning"
                @click="confirmSpoilt('spoilt-product-modal')"
            >
              <i class="fa fa-trash"></i> Proceed
              <b-spinner
                  v-if="SaveStatus"
                  variant="light"
                  small
                  label="Confirming"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
        <!-- modal ends -->
         <!-- modal confirm spoilt starts -->
         <b-modal
            header-bg-variant="warning"
            header-text-variant="light"
            body-text-variant="warning"
            footer-bg-variant="warning"
            footer-text-variant="warning"
            id="spoilt-delete-modal"
            hide-footer
            @hidden="resetConfirm"
        >
          <template #modal-title>Delete Spoilt Product {{ deletedata.name }}</template>
          <div class="form-group mb-3">
            <div class="input-group">
              <h5>
                Do you want to delete this spoilt stock record? Click Proceed Button to confirm.
              </h5>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="closeModal('spoilt-delete-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
                type="button"
                class="btn btn-warning"
                @click="deleteSpoilt('spoilt-delete-modal')"
            >
              <i class="fa fa-trash"></i> Proceed
              <b-spinner
                  v-if="SaveStatus"
                  variant="light"
                  small
                  label="Confirming"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
        <!-- modal ends -->
        <!-- modal starts -->
    <b-modal id="add-product-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add spoilt stock </template>
      <div class="form-group mb-3">
        <label>Category <span class="text-danger"></span></label>
        <select
            v-model="data.category"
            class="form-control"
        >
        <option value="0">Damage</option>
        <option value="1">Exchange</option>
        </select>

      </div>
      <div class="form-group mb-3" v-if="data.category == 1">
        <label>Customer <span class="text-danger"></span></label>
        <model-list-select
            :list="Customers ? Customers : []"
            v-model="data.customer_id"
            option-value="id"
            option-text="name"
            class="mb-3"
            placeholder="Select Customer"
        >
        </model-list-select>

      </div>
        <div class="form-group mb-3">
          <label>Select Product <span class="text-danger">*</span></label>
          <model-list-select
              :list="AgentStock ? AgentStock : []"
              v-model="data.product_id"
              option-value="product_id"
              option-text="name2"
              class="mb-3"
              placeholder="Select Product"
              @input="resetError()"
          >
          </model-list-select>
          <div class="text-danger" v-if="productError">
            <em>{{productError }}</em>
          </div>
        </div>
      

      <div class="form-group mb-3">
        <label>Quantity <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
              type="number"
              step="any"
              placeholder="Enter Quantity "
              class="form-control"
              @input="resetError()"
              v-model="data.quantity"
          />
        </div>
        <div class="text-danger" v-if="quantityError">
          <em>{{ quantityError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Date <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
              type="date"
              placeholder="Enter Product Name"
              class="form-control"
              v-model="data.date"
              @input="resetError()"

          />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Reason  <span class="text-danger"></span></label>
        <div class="input-group">
          <textarea
              placeholder="Enter Reason"
              class="form-control"
              @input="resetError()"
              v-model="data.description"
          />
        </div>

      </div>

      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="addSpoilt('add-product-modal')"
        > <i class="fa fa-check"></i>
          Submit
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
      </Layout>
    </template>
    
    <style>
    .btn-primary { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    </style>
    